exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-guest-checkin-jsx": () => import("./../../../src/pages/guest-checkin.jsx" /* webpackChunkName: "component---src-pages-guest-checkin-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-new-booking-jsx": () => import("./../../../src/pages/new-booking.jsx" /* webpackChunkName: "component---src-pages-new-booking-jsx" */)
}

